import { Collapse, List, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Page from "../../common/components/Page";
import CleanButton from "../../common/components/CleanButton";
import useEFile from "./useEFile";
import { RootState } from "../../store";
import EFileSummaryCard from "./EFileSummaryCard";
import { useNavigate } from "react-router";
import EFilePayment from "./e-file-payment/EFilePayment";

const EFileReview = () => {
  const { Panel } = Collapse;
  const { submitEFileRequest, eFileForm } = useEFile();
  const { activeEFileOption, eFileQuestions } = useSelector((state: RootState) => state.eFileApi);
  const history = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);


  useEffect(() => {
    if (!activeEFileOption) {
      history("/home");
    }
  }, [activeEFileOption])

  return (
    <Page>
      <Page.Title icon="check" title="E-File" />
      <Page.Content>
        <EFileSummaryCard></EFileSummaryCard>
        {eFileQuestions?.List?.length > 0 && (
          <Collapse accordion>
            <Panel header={`Questions (${eFileQuestions?.List.length})`} key={"1"}>
              <List size="large" bordered dataSource={eFileQuestions?.List}
                renderItem={item => (
                  <List.Item>
                    <div>
                      <strong>{item.QuestionText}</strong>
                      <br />
                      {item?.Answer}
                    </div>
                  </List.Item>
                )}></List>
            </Panel>
          </Collapse>
        )}
        {(activeEFileOption?.IsFeeImmediate && activeEFileOption?.FeeAmount > -1) ? (
          <CleanButton onClick={() => setIsModalVisible(true)} icon="money-bill">Submit Payment</CleanButton>) :
          (
            <CleanButton onClick={() => submitEFileRequest()} icon="check-double">Submit E-File</CleanButton>
          )}
        <Modal width={720} cancelText="Close" visible={isModalVisible} onOk={() => setIsModalVisible(false)} closable={false} cancelButtonProps={{ style: { display: 'none' } }} okButtonProps={{ style: { display: 'none' } }}>
          <EFilePayment feeDue={activeEFileOption?.FeeAmount} isFromEFile={true} setIsModalVisible={setIsModalVisible} ></EFilePayment>
        </Modal>
      </Page.Content>
    </Page>
  );
};

export default EFileReview;
